import React from 'react';
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Badge,
  HStack,
  Text,
} from '@chakra-ui/react';

export default function Section({
  name,
  description,
  disabled,
  children,
}: {
  name: string;
  description: string;
  disabled?: boolean;
  children: React.ReactNode;
}) {
  return (
    <AccordionItem border="none" isDisabled={disabled}>
      <AccordionButton px={0} py={3}>
        <HStack flex={1}>
          <Text fontWeight="semibold">{name}</Text>
          <Badge colorScheme={disabled ? 'gray' : 'green'} fontSize="xs">
            {disabled ? 'Needs Lead' : 'Ready'}
          </Badge>
        </HStack>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel px={0} pb={4}>
        <Text fontSize="sm" color="gray.500" mb={3}>
          {description}
        </Text>
        {children}
      </AccordionPanel>
    </AccordionItem>
  );
}
